export default "__VITE_ASSET__62616f30__"